import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Idle } from '@ng-idle/core';
import { BaseComponent } from 'src/app/components/base/base-component.component';

@Component({
  selector: 'app-timeout-warning-dialog',
  templateUrl: './timeout-warning-dialog.component.html',
  styleUrls: ['./timeout-warning-dialog.component.scss']
})
export class TimeoutWarningDialogComponent extends BaseComponent implements OnInit {

  countDown: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private idle: Idle
    ) { 
    super();
  }

  ngOnInit(): void {
    let initSeconds = this.data?.seconds;
    if(initSeconds) {
      this.countDown = initSeconds;
    }

    const sub$ = this.idle.onTimeoutWarning.subscribe((seconds) => {
      this.countDown = seconds;
    });
    this.addSubscription(sub$);
  }
}